import { render, staticRenderFns } from "./ListEventsGroup.vue?vue&type=template&id=3bb85de5&"
import script from "./ListEventsGroup.vue?vue&type=script&lang=js&"
export * from "./ListEventsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports